import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';

export const progress: OverWritable = {
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 4,
        overflow: 'hidden',
      },
      bar: {
        borderRadius: 4,
      },
      colorPrimary: ({ theme }) => ({
        backgroundColor:
          theme.palette.primary[isLightTheme(theme) ? 'lighter' : 'darker'],
      }),
      buffer: {
        backgroundColor: 'transparent',
      },
    },
  },
};
